import React, { FC, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons';
import { IHeader3_1 } from './params';

import Styles from './styles';
import { header, routing } from '../../../translates';

const Header: FC<{ isHome?: boolean; siteNameAlias: string; config: IHeader3_1; language: string }> = ({
  isHome,
  siteNameAlias,
  config,
  language,
}) => {
  const [navOpen, setNavOpen] = useState(false);

  return (
    <Styles $config={config}>
      <div className="header">
        <div className="container">
          <div className="header-wrapper">
            {isHome ? (
              <p className="header-logo">{siteNameAlias}</p>
            ) : (
              <a href="/" className="header-logo">
                {siteNameAlias}
              </a>
            )}
            <div className={`header-navlinks ${navOpen ? 'show' : ''}`}>
              <a href={routing[language].articles + '/'}>{header[language].article}</a>
              <a href={routing[language].contact + '/'}>{header[language].contact}</a>
              <div className="header-navlinks-button" onClick={() => setNavOpen((prev) => !prev)}>
                {navOpen ? <FontAwesomeIcon icon={faXmark} /> : <FontAwesomeIcon icon={faBars} />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Styles>
  );
};

export default Header;
